import { EnrolmentsListView } from '../Components/EnrolmentsListView';

export default function ActiveEnrolmentsPage() {
  return (
    <EnrolmentsListView
      fixedStatusID={1}
      title="Active Enrolments"
      subtitle="Enrolments confirmed and in progress"
    />
  );
}
